import React, { useCallback, useMemo } from "react";
import { Badge, Button, Col, Form, Row } from "react-bootstrap";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";

import GemDetailView from "../components/gems/GemDetailView";
import { GEM_LANGUAGE_OPTIONS } from "../constants/gemLanguages";

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

export default function GemDetailPage() {
  const { uid } = useParams();
  const query = useQuery();
  const navigate = useNavigate();
  const category_uid = query.get("category_uid") || undefined;
  const language_code = query.get("language_code") || "en";

  const setLanguageCode = useCallback(
    (code) => {
      const next = new URLSearchParams(query);
      next.set("language_code", code);
      if (category_uid) {
        next.set("category_uid", category_uid);
      } else {
        next.delete("category_uid");
      }
      navigate({ pathname: `/gems/${uid}`, search: `?${next.toString()}` }, { replace: true });
    },
    [category_uid, navigate, query, uid]
  );

  return (
    <div>
      <div className="page-header d-print-none">
        <div className="container-xl">
          <div className="row g-2 align-items-center">
            <div className="col">
              <div className="page-pretitle">Gem</div>
              <h2 className="page-title d-flex align-items-center gap-2">
                <span>Detail</span>
                <Badge bg="secondary" className="badge-pill">
                  {uid}
                </Badge>
              </h2>
              <div className="text-muted small mt-1">
                {category_uid ? (
                  <span className="me-2">category_uid: {category_uid}</span>
                ) : null}
              </div>
            </div>
            <div className="col-auto ms-auto d-print-none">
              <Row className="g-2 align-items-center">
                <Col xs="auto">
                  <Form.Label className="small text-muted mb-0 me-2">Language</Form.Label>
                  <Form.Select
                    size="sm"
                    value={language_code}
                    onChange={(e) => setLanguageCode(e.target.value)}
                    style={{ minWidth: 180 }}
                  >
                    {GEM_LANGUAGE_OPTIONS.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
                <Col xs="auto">
                  <Button
                    as={Link}
                    variant="outline-secondary"
                    to={category_uid ? `/categories/${category_uid}` : "/gems"}
                  >
                    Back
                  </Button>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>

      <GemDetailView uid={uid} category_uid={category_uid} language_code={language_code} />
    </div>
  );
}
